import(/* webpackMode: "eager", webpackExports: ["Hydrate","useHydrate"] */ "/app/node_modules/@tanstack/react-query/build/lib/Hydrate.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/app/node_modules/@tanstack/react-query/build/lib/isRestoring.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/app/node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["unstable_batchedUpdates"] */ "/app/node_modules/@tanstack/react-query/build/lib/reactBatchedUpdates.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/app/node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/app/node_modules/@tanstack/react-query/build/lib/useIsFetching.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating"] */ "/app/node_modules/@tanstack/react-query/build/lib/useIsMutating.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/app/node_modules/@tanstack/react-query/build/lib/useMutation.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@tanstack/react-query/build/lib/useQueries.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/app/node_modules/@tanstack/react-query/build/lib/useQuery.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/utils/helpers/fonts-helpers/fonts.ts\",\"import\":\"Poppins\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/utils/helpers/fonts-helpers/fonts.ts\",\"import\":\"Almarai\",\"arguments\":[{\"subsets\":[\"arabic\"],\"variable\":\"--font-almarai\",\"display\":\"swap\",\"style\":[\"normal\"],\"preload\":false,\"weight\":[\"300\",\"400\",\"700\"]}],\"variableName\":\"almarai\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/clients/CookieClearCheck.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/clients/GlobalErrorListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/clients/MarketingInitClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/clients/SyncAuthState.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/error_response/RetryButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/lib/CartDisabled.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/lib/ConfirmAccountModal.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/lib/StartStoreMessageModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/RedirectToExternalURL.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/CouponFromQP.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/scss/style.scss");
;
import(/* webpackMode: "eager", webpackExports: ["RouterEvents"] */ "/app/src/hooks/initial-hooks/RouterConfig.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/langProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicFont"] */ "/app/src/utils/helpers/fonts-helpers/DynamicFont.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/utils/helpers/InitGlobaleStateLeaf.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/utils/helpers/pixel-helpers/PageViewPixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/utils/helpers/pixel-helpers/PixelsHeadScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/utils/helpers/pixel-helpers/TagGateSync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/utils/helpers/WindowDimension.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/utils/Providers.tsx");
